import { memo, useCallback, useState } from 'react';

import { useTranslator } from '@picsart/rc/services/localization';
import { Tab, Tabs, TabPanel } from '@picsart/design-system/components/Tabs';

import TitleWithDescription from 'components/Colors/TitleWithDescription';
import ColorsCarousel from 'components/Colors/ColorsCarousel';

import usePageDataStore from 'stores/pageDataStore';
import CenteredContainer from '../CenteredContainer';

import { ColorsByCategoryProps } from './types';

import useStyles from './styles';
import useFilterData from './hooks/useFilterData';

function ColorsByCategory({ title, description }: ColorsByCategoryProps) {
  const colorPages = usePageDataStore(store => store.colorPages);
  const [activeTab, setActiveTab] = useState(0);
  const classes = useStyles();
  const translate = useTranslator();
  const { filterData } = useFilterData(colorPages);

  // very ugly hack to prevent scrolling to the tabs on load by cascade
  // todo: remove when problem is fixed
  const tabsRef = useCallback((node: HTMLDivElement) => {
    if (node !== null) {
      const el = node?.children[0]?.children[0];
      if (el) {
        el.scrollIntoView = () => {
          console.warn('Unnecessary scrollIntoView prevented!');
        };
      }
    }
  }, []);

  const handleTabChange = tabValue => {
    setActiveTab(tabValue);
  };

  return (
    <CenteredContainer>
      <div className={classes.root} data-testid="colors-by-category">
        <TitleWithDescription title={title} description={description} />
        <Tabs ref={tabsRef} className={classes.tabs} value={activeTab} onChange={handleTabChange}>
          {filterData.map(({ name }, index) => (
            <Tab key={`c${index}`} data-testid="colors-by-category-item">
              {translate(name)}
            </Tab>
          ))}
        </Tabs>

        {filterData.map(({ colors }, index) => {
          return (
            <TabPanel index={index} value={activeTab} key={`c${index}`}>
              <ColorsCarousel
                className={classes.carousel}
                colors={colors}
                rectangleClassName={classes.color}
              />
            </TabPanel>
          );
        })}
      </div>
    </CenteredContainer>
  );
}

export default memo(ColorsByCategory);
